/* import __COLOCATED_TEMPLATE__ from './event-timeline.hbs.js'; */
var _dec, _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';

/**
## Timeline

It displays the current status, call to action and a series of timeline events.

#### Contextual components

| Contextual Name     | Component                                               |
|---------------------|---------------------------------------------------------|
| timeline.status     | [event-timeline/status](/components/glass/event-timeline/status.html) |
| timeline.item       | [event-timeline/item](/components/glass/event-timeline/item.html)     |

@param {Boolean} showViewAllButton - if true there will be a viewAll button under the events
@param {Action} viewAllAction - action for the viewAll button if viewAll button is showing
@param {String} viewAllText - text for the viewAll button if it's showing

Style dependencies: `dashboard/components/_event-timeline.scss`

 */
let EventTimeline = (_dec = classNames('event-timeline'), _dec(_class = class EventTimeline extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "showViewAllButton", false);
    _defineProperty(this, "viewAllAction", null);
    _defineProperty(this, "viewAllText", null);
  }
}) || _class);
export { EventTimeline as default };